<template>
  <div
    v-if="labels"
    class="popup popup--wider"
    :class="{ active: marketingApprovalsModal }"
  >
    <div class="popup__wrapper" tabindex="-1">
      <button
        @click="$emit('close-modal-approvals')"
        class="popup__close"
        type="button"
      ></button>
      <div
        class="popup__content verification"
        v-scroll-lock="marketingApprovalsModal"
      >
        <h3 class="popup__heading">{{ labels.modal_approvals_header }}</h3>
        <p class="popup__subheading">
          {{ labels.modal_approvals_text }}
        </p>
        <button
          @click="$emit('close-modal-approvals')"
          class="ecommerce-addresses__button popup__button "
          type="button"
        >
          {{ labels.modal_approvals_button_close }}
        </button>
        <button @click="$emit('no-discount')" class="link" type="button">
          {{ labels.modal_approvals_button_continue }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URLS } from "@/js/apiUrls";
export default {
  name: "MarketingApprovalModal",
  props: {
    labels: Object,
    marketingApprovalsModal: Boolean
  },
  data: function() {
    return {};
  },
  created: function() {
    this.apiUrls = API_URLS;
  },
  updated: function() {},
  computed: {},
  watch: {
    marketingApprovalsModal: function(newVal) {
      if (newVal) {
        const that = this;
        setTimeout(function() {
          that.$el.querySelector(".popup__wrapper").focus();
        }, 100);
        this.$emit("trap-focus", this.$el);
      }
    }
  },
  mounted: function() {},
  methods: {},
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.popup {
  display: flex;
  position: fixed;
  bottom: 100vh;
  top: 0;
  left: 0;
  right: 0;
  z-index: 150;

  &:before {
    background: rgba(0, 0, 0, 0.6);
    content: "";
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s, visibility 0.3s;
  }

  &.active {
    &:before {
      opacity: 1;
      visibility: visible;
    }

    .popup__wrapper {
      top: 50%;
      transform: translate(-50%, -50%);
      opacity: 1;
      visibility: visible;
    }
  }

  &__wrapper {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    margin: auto;
    max-height: calc(100% - 40px);
    max-width: 570px;
    overflow: hidden;
    position: fixed;
    width: calc(100% - 40px);
    opacity: 0;
    visibility: hidden;
    transition: top 0.3s, opacity 0.3s, visibility 0.3s;
  }

  &__content {
    background: $white;
    padding: 20px;
    text-align: center;

    @media (min-width: $screen-sm-min) {
      padding: 35px 40px 30px;
    }
  }

  &__icon {
    height: 40px;
    margin-bottom: 15px;

    img {
      height: 40px;
      width: 40px;
    }
  }

  &__heading {
    font-size: 25px;
    line-height: 1.24;
    padding: 0 10px;
    margin-bottom: 4px;

    @media (min-width: $screen-sm-min) {
      font-size: 30px;
      line-height: 1.35;
      margin-bottom: 17px;
    }
  }

  &__subheading {
    font-size: 16px;
    line-height: 1.63;
    margin-bottom: 13px;

    @media (min-width: $screen-sm-min) {
      font-size: 17px;
      line-height: 1.88;
    }

    span {
      font-weight: 400;
    }
  }

  &__description {
    font-size: 16px;
    line-height: 1.63;
    margin-bottom: 0;

    .link {
      text-transform: none;
      font-weight: 400;
      color: $azure;
    }
  }

  &__verification-form {
    .form-group {
      max-width: 225px;
      margin: 0 auto;
    }

    label {
      font-size: 18px;
      top: 18px;
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__button {
    min-width: 185px;
    margin: 22px auto;
    font-size: 15px;
    padding-top: 9px;
    padding-bottom: 10px;

    @media (min-width: $screen-sm-min) {
      min-width: 435px;
      font-size: 16px;
      padding-top: 12px;
      padding-bottom: 11px;
      margin-top: 24px;
      margin-bottom: 18px;
    }
  }

  &__link {
    display: inline-block;
    margin-bottom: 0;
  }

  &__close {
    position: absolute;
    top: 4px;
    right: 13px;
    font-size: 36px;
    line-height: 1;

    @media (min-width: $screen-sm-min) {
      top: 8px;
      right: 16px;
    }

    &:after {
      content: "\d7";
      color: $azure;
    }
  }

  &--wider {
    .popup__wrapper {
      max-width: 758px;
    }

    .popup__button {
      @media (min-width: $screen-sm-min) {
        min-width: 295px;
      }
    }
  }
}
</style>
